import { render } from "./TheEvaluation.vue?vue&type=template&id=1da46e55&scoped=true"
import script from "./TheEvaluation.vue?vue&type=script&lang=js"
export * from "./TheEvaluation.vue?vue&type=script&lang=js"

import "./TheEvaluation.vue?vue&type=style&index=0&id=1da46e55&scoped=true&lang=css"

import exportComponent from "D:\\work\\feedback_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da46e55"]])

export default __exports__